export const SentStatusIcon = {
    d: 'M41,505H38v-4H24a2.006,2.006,0,0,0-2,2v11h2a3,3,0,0,0,6,0h6a3,3,0,0,0,6,0h2v-5ZM27,515.5a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,27,515.5Zm1.4-5.438-3.18-3.18,1.06-1.06,2.12,2.12,4.88-4.88,1.06,1.06ZM39,515.5a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,39,515.5ZM38,509v-2.5h2.5l1.96,2.5H38Z',
    transform: 'translate(-22 -501)'
};